import React from 'react';

import Placeholder from 'components/consumer/Placeholder';

const PDPProtectionPlanSelectorPlaceholder = () => (
  <div className="flex flex-col !w-full !h-[118px] mt-8 justify-between">
    <Placeholder type="text" loading row={1} className="!w-40 !h-6" />
    <Placeholder type="rect" loading className="!w-full !h-[73px]" />
  </div>
);

export default PDPProtectionPlanSelectorPlaceholder;
